import { InjectionToken } from '@angular/core';
import { AppSettingsDataService } from './app-settings.service';

export const APP_SETTINGS_TOKEN = new InjectionToken<AppSettingsDataService>('APP_SETTINGS_TOKEN');
